import DiskStatus from "./disk_status";
export default DiskStatus;
